export class Usuario {
  id!: number;
  email!: string;
  funcao!: string;
  emailConfirmado!: boolean;
  token!: string;
  validadeLogin!: Date;
  keyLogin!: string
}
